<template>
  <div
    class="container content-wrapper control e-dialog"
    style="text-align: left"
  >
    <div class="e-dlg-content">
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <label class="e-text">Fecha Impresion Desde</label>
          <ejs-datepicker
            id="filterStartDate"
            placeholder="Impresion Desde"
            required
            v-model="m_data.filterStartDate"
            :format="dateFormat"
            :strictMode="true"
            @change="validateField('filterStartDate')"
            @blur="validateField('filterStartDate')"
            :cssClass="hasError('filterStartDate') ? 'e-warning' : ''"
          ></ejs-datepicker>
          <span
            class="help e-text small"
            :class="{ 'e-warning': hasError('filterStartDate') }"
            v-text="m_errors.filterStartDate"
          >
          </span>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <label class="e-text">Fecha Impresion Hasta</label>
          <ejs-datepicker
            id="filterEndDate"
            placeholder="Impresion Hasta"
            required
            v-model="m_data.filterEndDate"
            :format="dateFormat"
            :strictMode="true"
            @change="validateField('filterEndDate')"
            @blur="validateField('filterEndDate')"
            :cssClass="hasError('filterEndDate') ? 'e-warning' : ''"
          ></ejs-datepicker>
          <span
            class="help e-text small"
            :class="{ 'e-warning': hasError('filterEndDate') }"
            v-text="m_errors.filterEndDate"
          >
          </span>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div>
            <label
              for="companies"
              style="padding: 0px 40px 0px 0"
              :class="{ 'e-warning': hasError('companies') }"
              >Compañia</label
            >
            <ejs-dropdownlist
              id="companies"
              :dataSource="company"
              :fields="fields"
              v-model="selected.company"
              :value="selected.company"
              :showClearButton="true"
              placeholder="Todas las Compañias"
              :cssClass="hasError('companies') ? 'e-warning' : ''"
            >
            </ejs-dropdownlist>
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('companies') }"
              v-text="m_errors.companies"
            >
            </span>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div>
            <label
              for="macroLines"
              style="padding: 0px 40px 0px 0"
              :class="{ 'e-warning': hasError('macroLines') }"
              >Macro Ramo</label
            >
            <ejs-dropdownlist
              id="macroLines"
              :dataSource="macroLine"
              :fields="fields"
              v-model="selected.macroLine"
              :value="selected.macroLine"
              :showClearButton="true"
              placeholder="Todos los Macro Ramos"
              :cssClass="hasError('macroLines') ? 'e-warning' : ''"
            >
            </ejs-dropdownlist>
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('macroLines') }"
              v-text="m_errors.macroLines"
            >
            </span>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div>
            <label
              for="insuranceLines"
              style="padding: 0px 40px 0px 0"
              :class="{ 'e-warning': hasError('insuranceLines') }"
              >Ramo</label
            >
            <ejs-dropdownlist
              ref="profileDropDown"
              id="insuranceLines"
              :dataSource="insuranceLine"
              :fields="fields"
              v-model="selected.insuranceLine"
              :value="selected.insuranceLine"
              :showClearButton="true"
              placeholder="Todos los Ramos"
              :cssClass="hasError('insuranceLines') ? 'e-warning' : ''"
            ></ejs-dropdownlist>
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('insuranceLines') }"
              v-text="m_errors.insuranceLines"
            >
            </span>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div>
            <label for="branchOfficesId" style="padding: 0px 40px 0px 0"
              >Sucursales</label
            >
            <ejs-dropdownlist
              ref="profileDropDown"
              id="branchOffices"
              :dataSource="branchOffice"
              :fields="fields"
              v-model="selected.branchOffice"
              :value="selected.branchOffice"
              :showClearButton="true"
              placeholder="Todas las Sucursales"
            ></ejs-dropdownlist>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div>
            <label for="businessUnitId" style="padding: 0px 40px 0px 0"
              >Unidad Comercial</label
            >
            <ejs-dropdownlist
              ref="profileDropDown"
              id="businessUnits"
              :dataSource="businessUnit"
              :fields="fields"
              v-model="selected.businessUnit"
              :value="selected.businessUnit"
              :showClearButton="true"
              placeholder="Todas las Unidades Comerciales"
              :cssClass="hasError('businessUnits') ? 'e-warning' : ''"
            ></ejs-dropdownlist>
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('businessUnits') }"
              v-text="m_errors.businessUnits"
            >
            </span>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div>
            <label
              for="endorsementType"
              style="padding: 0px 40px 0px 0"
              :class="{ 'e-warning': hasError('endorsementType') }"
              >Grupo Endoso</label
            >
            <ejs-dropdownlist
              ref="profileDropDown"
              id="endorsementType"
              :dataSource="endorsementType"
              :fields="fields"
              v-model="selected.endorsementType"
              :value="selected.endorsementType"
              :showClearButton="true"
              placeholder="Todos los Grupos de Endosos"
            ></ejs-dropdownlist>
          </div>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <div>
            <label
              for="endorsementSubType"
              style="padding: 0px 40px 0px 0"
              :class="{ 'e-warning': hasError('endorsementSubType') }"
              >Tipo Endoso</label
            >
            <ejs-dropdownlist
              ref="profileDropDown"
              id="endorsementSubType"
              :dataSource="endorsementSubType"
              :fields="fields"
              v-model="selected.endorsementSubType"
              :value="selected.endorsementSubType"
              :showClearButton="true"
              placeholder="Todos los Tipos de Endosos"
            >
            </ejs-dropdownlist>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <label class="e-text">Codigo Agente</label>
          <input
            id="holder"
            class="e-input"
            type="text"
            required
            v-model="m_data.agentId"
            :class="{ 'e-warning': hasError('holder') }"
            @input="validateField('holder')"
            @blur="validateField('holder')"
            placeholder="Codigo Agente"
            :disabled="m_data.isAgent"
          />
          <span
            class="help e-text small"
            :class="{ 'e-warning': hasError('holder') }"
            v-text="m_errors.holder"
          >
          </span>
        </div>
        <!-- <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <label class="e-text">Codigo Producto</label>
          <input
            id="product"
            class="e-input"
            type="text"
            required
            v-model="m_data.productId"
            :class="{ 'e-warning': hasError('product') }"
            @input="validateField('product')"
            @blur="validateField('product')"
            placeholder="Codigo Producto"
          />
          <span
            class="help e-text small"
            :class="{ 'e-warning': hasError('product') }"
            v-text="m_errors.product"
          >
          </span>
        </div> -->

        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <label class="e-text">Codigo Tomador</label>
          <input
            id="agent"
            class="e-input"
            type="text"
            required
            v-model="m_data.holderId"
            :class="{ 'e-warning': hasError('agent') }"
            @input="validateField('agent')"
            @blur="validateField('agent')"
            placeholder="Codigo Tomador"
          />
          <span
            class="help e-text small"
            :class="{ 'e-warning': hasError('agent') }"
            v-text="m_errors.agent"
          >
          </span>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <label class="e-text">Doc. Tomador</label>
          <input
            id="policyHolderId"
            class="e-input"
            type="text"
            required
            v-model="m_data.policyHolderId"
            :class="{ 'e-warning': hasError('policyHolderId') }"
            @input="validateField('policyHolderId')"
            @blur="validateField('policyHolderId')"
            placeholder="Documento Tomador"
          />
          <span
            class="help e-text small"
            :class="{ 'e-warning': hasError('holder') }"
            v-text="m_errors.policyHolderId"
          >
          </span>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <label class="e-text">Numero De Poliza</label>
          <input
            id="policy"
            class="e-input"
            type="text"
            required
            v-model="m_data.policyNumber"
            :class="{ 'e-warning': hasError('policy') }"
            @input="validateField('policy')"
            @blur="validateField('policy')"
            placeholder="Numero De Poliza"
          />
          <span
            class="help e-text small"
            :class="{ 'e-warning': hasError('policy') }"
            v-text="m_errors.policy"
          >
          </span>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <label class="e-text">Emisión Desde</label>
          <ejs-datepicker
            id="validFrom"
            placeholder="Emision Desde"
            required
            v-model="m_data.validFrom"
            :format="dateFormat"
            :strictMode="true"
            @change="validateField('validFrom')"
            @blur="validateField('validFrom')"
            :cssClass="hasError('validFrom') ? 'e-warning' : ''"
          ></ejs-datepicker>
          <span
            class="help e-text small"
            :class="{ 'e-warning': hasError('validFrom') }"
            v-text="m_errors.validFrom"
          >
          </span>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
          <label class="e-text">Emision Hasta</label>
          <ejs-datepicker
            id="validThru"
            placeholder="Emision Hasta"
            required
            v-model="m_data.validThru"
            :format="dateFormat"
            :strictMode="true"
            @change="validateField('validThru')"
            @blur="validateField('validThru')"
            :cssClass="hasError('validThru') ? 'e-warning' : ''"
          ></ejs-datepicker>
          <span
            class="help e-text small"
            :class="{ 'e-warning': hasError('validThru') }"
            v-text="m_errors.validThru"
          >
          </span>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4" style="display: flex">
          <div class="e-btn-group" style="align-self: flex-end; margin-top: 10px;">
            <ejs-button
              @click.native="validateForm"
              :isPrimary="true"
              iconCss="e-icons icon-save inline-command"
              cssClass="e-flat e-noback"
              >Filtrar Resultados</ejs-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
/*import { object, string, number, yup, when } from "yup";*/

// import { FormActionEnum } from "../../services/enums.js";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
/* Plugins de Syncfusion */
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { SwitchPlugin } from "@syncfusion/ej2-vue-buttons";
import { NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";

/* Utilidades Syncfusion */
// import { DialogUtility } from "@syncfusion/ej2-popups";

/* Validación con YUP*/

import * as Yup from "yup";
import { es } from "yup-locales";
import { setLocale } from "yup";
setLocale(es);

Vue.use(DialogPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(SwitchPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);

export default Vue.extend({
  name: "dashboard-filter",
  mixins: [PermissionMixin, ToastMixin],
  async beforeDestroy() {
    this.initFilters();
  },
  computed: {
    branchOffice() {
      var hasData =
        this.filterSources.branchOffices &&
        this.filterSources.branchOffices.length > 0;
      if (!hasData) return [];
      const newArray = JSON.parse(
        JSON.stringify(
          this.filterSources.branchOffices.map(function (row) {
            return { id: row.CodigoSucursal, name: row.DescSucursal };
          })
        )
      );

      if (newArray != undefined && newArray.length > 0) {
        return newArray.sort((a, b) =>
          a.name.localeCompare(b.name, "es", { ignorePunctuation: true })
        );
      }
      return [];
    },
    businessUnit() {
      var hasData =
        this.filterSources.businessUnits &&
        this.filterSources.businessUnits.length > 0;
      if (!hasData) return [];
      var branchOfficeList = this.selected.branchOffice;
      var company = this.selected.company;
      const newArray = JSON.parse(
        JSON.stringify(
          this.filterSources.businessUnits
            .filter(
              (x) =>
                (branchOfficeList == null ||
                  branchOfficeList.length == 0 ||
                  branchOfficeList == x.CodigoSucursal) &&
                (company == null ||
                  company.length == 0 ||
                  company == x.IdUnidadComercial.toString().charAt(0))
            )
            .map(function (row) {
              return {
                id: row.IdUnidadComercial,
                name: row.DescUnidadComercial
              };
            })
        )
      );

      if (newArray != undefined && newArray.length > 0) {
        return newArray.sort((a, b) =>
          a.name.localeCompare(b.name, "es", { ignorePunctuation: true })
        );
      }
      return [];
    },
    company() {
      var hasData =
        this.filterSources.companies && this.filterSources.companies.length > 0;
      if (!hasData) return [];
      const newArray = JSON.parse(
        JSON.stringify(
          this.filterSources.companies.map(function (row) {
            return { id: row.integerValue, name: row.description };
          })
        )
      );

      if (newArray != undefined && newArray.length > 0) {
        return newArray.sort((a, b) =>
          a.name.localeCompare(b.name, "es", { ignorePunctuation: true })
        );
      }

      return [];
    },
    macroLine() {
      var hasData =
        this.filterSources.macroLines &&
        this.filterSources.macroLines.length > 0;
      if (!hasData) return [];
      const newArray = JSON.parse(
        JSON.stringify(
          this.filterSources.macroLines.map(function (row) {
            return { id: row.IdMacroRamo, name: row.DescMacroramo };
          })
        )
      );

      if (newArray != undefined && newArray.length > 0) {
        return newArray.sort((a, b) =>
          a.name.localeCompare(b.name, "es", { ignorePunctuation: true })
        );
      }

      return [];
    },
    insuranceLine() {
      var hasData =
        this.filterSources.insuranceLines &&
        this.filterSources.insuranceLines.length > 0;
      if (!hasData) return [];
      var macroList = this.selected.macroLine;
      //var companyId = this.selected.company;

      const newArray = JSON.parse(
        JSON.stringify(
          this.filterSources.insuranceLines
            .filter((x) => {
              var ret = false;

              ret =
                macroList == null ||
                macroList.length == 0 ||
                macroList == x.IdMacroRamo;

              if (ret && macroList != null) {
                ret = x.IdRamo.toString().charAt(0) == macroList.toString();
              }
              return ret;
            })
            .map(function (row) {
              return { id: row.IdRamo, name: row.DescRamo };
            })
        )
      );

      if (newArray != undefined && newArray.length > 0) {
        return newArray.sort((a, b) =>
          a.name.localeCompare(b.name, "es", { ignorePunctuation: true })
        );
      }
      return [];
    },
    endorsementType() {
      var hasData =
        this.filterSources.endorsementTypes &&
        this.filterSources.endorsementTypes.length > 0;
      if (!hasData) return [];
      var company = this.selected.company;
      const newArray = JSON.parse(
        JSON.stringify(
          this.filterSources.endorsementTypes
            .filter(
              (x) =>
                company == null ||
                company.length == 0 ||
                company == x.IdGrupoEndoso.toString().charAt(0)
            )
            .map(function (row) {
              return {
                id: row.IdGrupoEndoso,
                name: row.DescGrupodeEndoso,
                codGrupo: row.CodigoGrupoEndoso
              };
            })
        )
      );

      if (newArray != undefined && newArray.length > 0) {
        return newArray.sort((a, b) =>
          a.name.localeCompare(b.name, "es", { ignorePunctuation: true })
        );
      }

      return [];
    },
    endorsementSubType() {
      var hasData =
        this.filterSources.endorsementSubTypes &&
        this.filterSources.endorsementSubTypes.length > 0;
      if (!hasData) return [];
      var endorsementType = this.selected.endorsementType;

      var id = "";
      if (endorsementType != null && endorsementType != undefined)
        id = endorsementType.toString();

      const newArray = JSON.parse(
        JSON.stringify(
          this.filterSources.endorsementSubTypes
            .filter(
              (x) => x.IdTipoEndoso.toString().substring(0, 3) == id || id == ""
            )
            .map(function (row) {
              return { id: row.IdTipoEndoso, name: row.DescTipoEndoso };
            })
        )
      );

      if (newArray != undefined && newArray.length > 0) {
        return newArray.sort((a, b) =>
          a.name.localeCompare(b.name, "es", { ignorePunctuation: true })
        );
      }

      return [];
    }
  },
  data() {
    return {
      /* Datos del Componente*/
      isValid: false,
      isMounted: false,
      validationSchema: {},
      m_errors: {},
      m_data: {},
      /* Datos del Dialogo de Syncfusion*/
      isModal: true,
      /*isOpen: false,*/
      target: document.getElementById("dialog"),
      width: this.isMobile ? "500px" : "70%",
      fields: { text: "name", value: "id" },
      filter: { type: "CheckBox" },
      branchOffices: null,
      businessUnits: null,
      endorsementTypes: null,
      endorsementSubTypes: null,
      macroLines: null,
      companies: null,
      insuranceLines: null,
      formData: null,
      formAction: null,
      dateFormat: "yyyy/MM/dd",
      selected: {
        company: null,
        macroLine: null,
        insuranceLine: null,
        branchOffice: null,
        businessUnit: null,
        endorsementType: null,
        endorsementSubType: null
      }
    };
  },
  created() {},
  async mounted() {
    try {
      this.buildYupSchema();

      //console.log(this.filterSources);

      this.m_data = JSON.parse(JSON.stringify(this.filterData));
      this.setSelectedItems();

      this.isMounted = true;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    initFilters() {
      this.selected = {
        company: null,
        macroLine: null,
        insuranceLine: null,
        branchOffice: null,
        businessUnit: null,
        endorsementType: null,
        endorsementSubType: null
      };
    },
    DialogClose() {
      try {
        this.initFilters();
        this.clearErrors();
      } catch (error) {
        console.log(error);
      }
    },
    clearErrors() {
      this.m_errors = {};
    },
    buildYupSchema() {
      /*Hack para esLint*/

      this.validationSchema = Yup.object().shape({
        isNew: Yup.boolean(),
        agentId: Yup.number().notRequired(),
        productId: Yup.number().notRequired(),
        holderId: Yup.number().notRequired(),
        policyHolderId: Yup.string().notRequired().nullable(),
        policyNumber: Yup.number().notRequired(),
        conditionId: Yup.number().required(),
        validFrom: Yup.string().notRequired().nullable(),
        validThru: Yup.string().notRequired().nullable()
      });
    },
    hasError(field) {
      return !!this.m_errors[field];
    },
    async validateField(field) {
      Vue.set(this.m_errors, field, "");
    },
    setSelectedItems() {
      var instance = this;
      if (this.m_data == null || this.m_data == undefined) return;

      var limit = JSON.parse(JSON.stringify(this.m_data));

      var hasData = limit.macroLineId && limit.macroLineId > 0;
      if (hasData) {
        instance.selected.macroLine = limit.macroLineId;
      }

      hasData = limit.companyId && limit.companyId > 0;
      if (hasData) {
        instance.selected.company = limit.companyId;
      }

      hasData = limit.lineId && limit.lineId > 0;
      if (hasData) {
        instance.selected.insuranceLine = limit.lineId;
      }

      hasData = limit.branchOfficeId && limit.branchOfficeId > 0;
      if (hasData) {
        instance.selected.branchOffice = limit.branchOfficeId;
      }

      hasData = limit.businessUnitId && limit.businessUnitId > 0;
      if (hasData) {
        instance.selected.businessUnit = limit.businessUnitId;
      }

      hasData = limit.endorsementTypeId && limit.endorsementTypeId > 0;
      if (hasData) {
        instance.selected.endorsementType = limit.endorsementTypeId;
      }

      hasData = limit.endorsementSubTypeId && limit.endorsementSubTypeId > 0;
      if (hasData) {
        instance.selected.endorsementSubType = limit.endorsementSubTypeId;
      }
    },
    setDataFromSelected() {
      this.m_data.companyId = this.selected.company;
      this.m_data.macroLineId = this.selected.macroLine;
      this.m_data.lineId = this.selected.insuranceLine;
      this.m_data.branchOfficeId = this.selected.branchOffice;
      this.m_data.businessUnitId = this.selected.businessUnit;
      this.m_data.endorsementTypeId = this.selected.endorsementType;
      this.m_data.endorsementSubTypeId = this.selected.endorsementSubType;

      this.m_errors = {};
    },
    async validateForm() {
      this.setDataFromSelected();
      this.isValid = false;
      var valid = await this.validateData();
      if (!valid) return;
      try {
        this.$emit("OnFilterAction", this.m_data);
      } catch (error) {
        if (error.inner != undefined) {
          error.inner.forEach((error) => {
            Vue.set(this.m_errors, error.path, error.message);
          });
        } else {
          console.log(error);
        }
      }
    },

     async validateData() {
      var isValid = true;   
      if (this.m_data.filterStartDate == null) {
        Vue.set(
          this.m_errors,
          "filterStartDate",
          "Debe seleccionar una fecha de impresion!"          
        );
        isValid = false;
      }

      if (this.m_data.filterEndDate == null) {
        Vue.set(
          this.m_errors,
          "filterEndDate",
          "Debe seleccionar una fecha de impresion!"          
        );
        isValid = false;
      }

      return isValid;
    },
    setFormData(data, action) {
      this.formData = data;
      this.formAction = action;
    }
  },
  props: {
    filterData: {
      type: Object,
      required: true,
      default: function () {
        return null;
      }
    },
    filterSources: {
      type: Object,
      required: true,
      default: function () {
        return null;
      }
    }
  }
});
</script>

<style>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-dropdowns/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-calendars/styles/fabric.css);
@import url(../form-icons.css);

/*
.e-dialog.dialog-papirus .e-dlg-header-content {
  background: rgb(66, 66, 66);
}

.e-dialog.dialog-papirus .e-btn .e-btn-icon.e-icon-dlg-close {
  font-size: 16px;
  color: 999;
  font-weight: bold;
}

.dialog-papirus .e-btn-icon.e-icon-dlg-close.e-save.e-icons:before {
  color: #fff;
}

.dialog-papirus.e-dialog .e-dlg-header {
  color: #fff;

  font-size: 20px;
  font-weight: normal;
}
*/

.dialog-papirus.e-dialog .e-dlg-header {
  color: #0078d6;
  font-size: 20px;
  font-weight: normal;
}

/*
.dialog-papirus.e-dialog .e-dlg-header::before {
  font-family: "forms";
  padding: 0px 10px 0px 0px;
  content: "\e506";
}
*/
.content-wrapper div.row {
  padding: 5px 0px;
}

.switch-label {
  padding: 0px 0px 0px 20px;
  margin: auto;
  cursor: pointer;
}

.e-save.e-icons:before,
.e-save.e-icons:before {
  content: "\e609";
}

@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }

  .e-input-section .col-xs-6,
  .e-input-section .col-xs-4,
  .e-input-section .col-xs-12 {
    padding: 10px 5px;
    width: 100%;
  }

  .content-wrapper div.row {
    padding: 0px;
  }
}
</style>
: {}